/**
 * @generated SignedSource<<d4199a6c7bb5f7fd28b2217a5ee780e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PersonBulkCreateInput = {
  people: ReadonlyArray<PersonBulkCreate>;
};
export type PersonBulkCreate = {
  email?: string | null | undefined;
  first_name: string;
  last_name: string;
  manager_ids?: ReadonlyArray<number | null | undefined> | null | undefined;
  role_name: string;
};
export type PersonBulkCreateMutation$variables = {
  input: PersonBulkCreateInput;
  plannerStartDate?: any | null | undefined;
};
export type PersonBulkCreateMutation$data = {
  readonly action_person_bulk_create: ReadonlyArray<{
    readonly account: {
      readonly id: number;
      readonly people_aggregate: {
        readonly aggregate: {
          readonly count: number;
        } | null | undefined;
      };
      readonly rate_cards: ReadonlyArray<{
        readonly id: number;
        readonly name: string | null | undefined;
        readonly role_charge_out_rates: ReadonlyArray<{
          readonly charge_out_rate: number | null | undefined;
          readonly rate_card_id: number;
          readonly role: {
            readonly id: number;
            readonly name: string;
          };
          readonly role_id: number;
        }>;
      }>;
      readonly roles: ReadonlyArray<{
        readonly active: boolean;
        readonly id: number;
        readonly name: string;
      }>;
    } | null | undefined;
    readonly person: {
      readonly account_id: number;
      readonly active: boolean;
      readonly actuals_aggregate: {
        readonly aggregate: {
          readonly count: number;
        } | null | undefined;
      };
      readonly archivable: boolean | null | undefined;
      readonly assignments: ReadonlyArray<{
        readonly id: number;
      }>;
      readonly assignments_aggregate: {
        readonly aggregate: {
          readonly count: number;
        } | null | undefined;
      };
      readonly competencies: ReadonlyArray<{
        readonly id: number;
      }>;
      readonly contracts: ReadonlyArray<{
        readonly cost: number | null | undefined;
        readonly employment_type: string;
        readonly end_date: string | null | undefined;
        readonly id: number;
        readonly job_title: string | null | undefined;
        readonly minutes_per_day: number | null | undefined;
        readonly role: {
          readonly id: number;
          readonly name: string;
        };
        readonly rostered_days: ReadonlyArray<number> | null | undefined;
        readonly start_date: string | null | undefined;
      }>;
      readonly custom_checkbox_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: boolean;
      }>;
      readonly custom_date_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: any | null | undefined;
      }>;
      readonly custom_select_values: ReadonlyArray<{
        readonly optionId: number;
        readonly typeId: number;
      }>;
      readonly custom_text_values: ReadonlyArray<{
        readonly typeId: number;
        readonly value: string;
      }>;
      readonly email: string | null | undefined;
      readonly first_name: string;
      readonly holidays_group: {
        readonly id: number;
      } | null | undefined;
      readonly id: number;
      readonly is_placeholder: boolean;
      readonly last_name: string;
      readonly project_memberships: ReadonlyArray<{
        readonly id: number;
      }>;
      readonly references: any;
      readonly tags: any;
      readonly team: {
        readonly id: number;
        readonly name: string;
      } | null | undefined;
      readonly team_id: number | null | undefined;
      readonly time_offs: ReadonlyArray<{
        readonly end_date: string | null | undefined;
        readonly ext_time_off_links: ReadonlyArray<{
          readonly active: boolean;
          readonly ext_time_off_id: number;
          readonly external: {
            readonly __typename: "ext_time_off";
            readonly id: number;
            readonly integration_id: number;
          } | null | undefined;
          readonly external_id: number;
          readonly time_off_id: number;
        }>;
        readonly id: number;
        readonly start_date: string | null | undefined;
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"PersonSidePanel_person">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type PersonBulkCreateMutation = {
  response: PersonBulkCreateMutation$data;
  variables: PersonBulkCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "plannerStartDate"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "first_name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "last_name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "is_placeholder",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "account_id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "team_id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "references",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archivable",
  "storageKey": null
},
v13 = {
  "alias": "start_date",
  "args": null,
  "kind": "ScalarField",
  "name": "start_date_runn",
  "storageKey": null
},
v14 = {
  "alias": "cost",
  "args": null,
  "kind": "ScalarField",
  "name": "cost_private",
  "storageKey": null
},
v15 = {
  "alias": "end_date",
  "args": null,
  "kind": "ScalarField",
  "name": "end_date_runn",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "job_title",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutes_per_day",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "employment_type",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rostered_days",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v21 = [
  (v2/*: any*/),
  (v20/*: any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "roles",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v23 = [
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "_gte",
            "variableName": "plannerStartDate"
          }
        ],
        "kind": "ObjectValue",
        "name": "end_date_iso"
      }
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
],
v24 = [
  (v2/*: any*/)
],
v25 = {
  "alias": null,
  "args": (v23/*: any*/),
  "concreteType": "assignments",
  "kind": "LinkedField",
  "name": "assignments",
  "plural": true,
  "selections": (v24/*: any*/),
  "storageKey": null
},
v26 = {
  "_eq": true
},
v27 = [
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "active": (v26/*: any*/)
    }
  }
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integration_id",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": (v23/*: any*/),
  "concreteType": "time_offs",
  "kind": "LinkedField",
  "name": "time_offs",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v13/*: any*/),
    (v15/*: any*/),
    {
      "alias": null,
      "args": (v27/*: any*/),
      "concreteType": "ext_time_off_link",
      "kind": "LinkedField",
      "name": "ext_time_off_links",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "time_off_id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ext_time_off_id",
          "storageKey": null
        },
        (v3/*: any*/),
        {
          "alias": "external_id",
          "args": null,
          "kind": "ScalarField",
          "name": "ext_time_off_id",
          "storageKey": null
        },
        {
          "alias": "external",
          "args": null,
          "concreteType": "ext_time_off",
          "kind": "LinkedField",
          "name": "ext_time_off",
          "plural": false,
          "selections": [
            (v28/*: any*/),
            (v2/*: any*/),
            (v29/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": "ext_time_off_links(where:{\"active\":{\"_eq\":true}})"
    }
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "teams",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "project_members",
  "kind": "LinkedField",
  "name": "project_memberships",
  "plural": true,
  "selections": (v24/*: any*/),
  "storageKey": null
},
v33 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
],
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "actuals_aggregate",
  "kind": "LinkedField",
  "name": "actuals_aggregate",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "actuals_aggregate_fields",
      "kind": "LinkedField",
      "name": "aggregate",
      "plural": false,
      "selections": (v33/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "assignments_aggregate",
  "kind": "LinkedField",
  "name": "assignments_aggregate",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "assignments_aggregate_fields",
      "kind": "LinkedField",
      "name": "aggregate",
      "plural": false,
      "selections": (v33/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_text_values",
  "kind": "LinkedField",
  "name": "custom_text_values",
  "plural": true,
  "selections": [
    (v36/*: any*/),
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_text_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_date_values",
  "kind": "LinkedField",
  "name": "custom_date_values",
  "plural": true,
  "selections": [
    (v36/*: any*/),
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_date_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_select_values",
  "kind": "LinkedField",
  "name": "custom_select_values",
  "plural": true,
  "selections": [
    {
      "alias": "optionId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_select_option_id",
      "storageKey": null
    },
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_select_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "custom_checkbox_values",
  "kind": "LinkedField",
  "name": "custom_checkbox_values",
  "plural": true,
  "selections": [
    (v36/*: any*/),
    {
      "alias": "typeId",
      "args": null,
      "kind": "ScalarField",
      "name": "custom_checkbox_type_id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "accounts",
  "kind": "LinkedField",
  "name": "account",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "rate_cards",
      "kind": "LinkedField",
      "name": "rate_cards",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v20/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "role_charge_out_rates",
          "kind": "LinkedField",
          "name": "role_charge_out_rates",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "role_id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rate_card_id",
              "storageKey": null
            },
            (v22/*: any*/),
            {
              "alias": "charge_out_rate",
              "args": null,
              "kind": "ScalarField",
              "name": "charge_out_rate_private",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "where",
          "value": {
            "active": (v26/*: any*/),
            "is_placeholder": {
              "_eq": false
            }
          }
        }
      ],
      "concreteType": "people_aggregate",
      "kind": "LinkedField",
      "name": "people_aggregate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "people_aggregate_fields",
          "kind": "LinkedField",
          "name": "aggregate",
          "plural": false,
          "selections": (v33/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": "people_aggregate(where:{\"active\":{\"_eq\":true},\"is_placeholder\":{\"_eq\":false}})"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "roles",
      "kind": "LinkedField",
      "name": "roles",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v20/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "user_id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PersonBulkCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PersonBulkCreateOutput",
        "kind": "LinkedField",
        "name": "action_person_bulk_create",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "people",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "contracts",
                "kind": "LinkedField",
                "name": "contracts",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v22/*: any*/)
                ],
                "storageKey": null
              },
              (v25/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "competencies",
                "kind": "LinkedField",
                "name": "competencies",
                "plural": true,
                "selections": (v24/*: any*/),
                "storageKey": null
              },
              (v32/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "holidays_groups",
                "kind": "LinkedField",
                "name": "holidays_group",
                "plural": false,
                "selections": (v24/*: any*/),
                "storageKey": null
              },
              (v34/*: any*/),
              (v35/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PersonSidePanel_person"
              }
            ],
            "storageKey": null
          },
          (v41/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PersonBulkCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PersonBulkCreateOutput",
        "kind": "LinkedField",
        "name": "action_person_bulk_create",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "people",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "contracts",
                "kind": "LinkedField",
                "name": "contracts",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "roles",
                    "kind": "LinkedField",
                    "name": "role",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v20/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": "default_hour_cost",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "default_hour_cost_private",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v25/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "competencies",
                "kind": "LinkedField",
                "name": "competencies",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "level",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "skills",
                    "kind": "LinkedField",
                    "name": "skill",
                    "plural": false,
                    "selections": (v21/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v32/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "holidays_groups",
                "kind": "LinkedField",
                "name": "holidays_group",
                "plural": false,
                "selections": (v21/*: any*/),
                "storageKey": null
              },
              (v34/*: any*/),
              (v35/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "image_key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "people_notes_aggregate",
                "kind": "LinkedField",
                "name": "people_notes_aggregate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "people_notes_aggregate_fields",
                    "kind": "LinkedField",
                    "name": "aggregate",
                    "plural": false,
                    "selections": (v33/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "people_links",
                "kind": "LinkedField",
                "name": "links",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "href",
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "show_in_planner",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "people_managers",
                "kind": "LinkedField",
                "name": "managers",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v42/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "people",
                    "kind": "LinkedField",
                    "name": "person",
                    "plural": false,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v27/*: any*/),
                "concreteType": "ext_person_link",
                "kind": "LinkedField",
                "name": "ext_person_links",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "person_id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ext_person_id",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": "external_id",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ext_person_id",
                    "storageKey": null
                  },
                  {
                    "alias": "external",
                    "args": null,
                    "concreteType": "ext_person",
                    "kind": "LinkedField",
                    "name": "ext_person",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v28/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "remote_id",
                        "storageKey": null
                      },
                      (v29/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "ext_person_links(where:{\"active\":{\"_eq\":true}})"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "people_notes",
                "kind": "LinkedField",
                "name": "people_notes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "note",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "created_at",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updated_at",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "creator_email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "created_by",
                    "storageKey": null
                  },
                  (v42/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "user_accounts",
                    "kind": "LinkedField",
                    "name": "user_account",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "users",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v41/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ccf13e37dd78779ed90e2e09e59cfd0b",
    "id": null,
    "metadata": {},
    "name": "PersonBulkCreateMutation",
    "operationKind": "mutation",
    "text": "mutation PersonBulkCreateMutation(\n  $input: PersonBulkCreateInput!\n  $plannerStartDate: date\n) {\n  action_person_bulk_create(input: $input) {\n    person {\n      id\n      active\n      first_name\n      last_name\n      email\n      is_placeholder\n      account_id\n      tags\n      team_id\n      references\n      archivable\n      contracts {\n        id\n        start_date: start_date_runn\n        cost: cost_private\n        end_date: end_date_runn\n        job_title\n        minutes_per_day\n        employment_type\n        rostered_days\n        role {\n          id\n          name\n        }\n      }\n      assignments(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n        id\n      }\n      time_offs(where: {end_date_iso: {_gte: $plannerStartDate}}) {\n        id\n        start_date: start_date_runn\n        end_date: end_date_runn\n        ext_time_off_links(where: {active: {_eq: true}}) {\n          time_off_id\n          ext_time_off_id\n          active\n          external_id: ext_time_off_id\n          external: ext_time_off {\n            __typename\n            id\n            integration_id\n          }\n        }\n      }\n      team {\n        id\n        name\n      }\n      competencies {\n        id\n      }\n      project_memberships {\n        id\n      }\n      holidays_group {\n        id\n      }\n      actuals_aggregate {\n        aggregate {\n          count\n        }\n      }\n      assignments_aggregate {\n        aggregate {\n          count\n        }\n      }\n      custom_text_values {\n        value\n        typeId: custom_text_type_id\n      }\n      custom_date_values {\n        value\n        typeId: custom_date_type_id\n      }\n      custom_select_values {\n        optionId: custom_select_option_id\n        typeId: custom_select_type_id\n      }\n      custom_checkbox_values {\n        value\n        typeId: custom_checkbox_type_id\n      }\n      ...PersonSidePanel_person\n    }\n    account {\n      id\n      rate_cards {\n        id\n        name\n        role_charge_out_rates {\n          role_id\n          rate_card_id\n          role {\n            id\n            name\n          }\n          charge_out_rate: charge_out_rate_private\n        }\n      }\n      people_aggregate(where: {active: {_eq: true}, is_placeholder: {_eq: false}}) {\n        aggregate {\n          count\n        }\n      }\n      roles {\n        id\n        name\n        active\n      }\n    }\n  }\n}\n\nfragment ConfirmContractForm_person on people {\n  id\n  email\n}\n\nfragment EditPersonForm_person on people {\n  id\n  first_name\n  last_name\n  managers {\n    id\n    user_id\n    person {\n      id\n    }\n  }\n  email\n  image_key\n  tags\n  references\n  active\n  archivable\n  team {\n    name\n    id\n  }\n  contracts {\n    id\n    rostered_days\n    employment_type\n    minutes_per_day\n    cost: cost_private\n    start_date: start_date_runn\n    end_date: end_date_runn\n    role {\n      id\n      name\n      active\n    }\n    job_title\n  }\n  competencies {\n    id\n    level\n    skill {\n      id\n      name\n    }\n  }\n  holidays_group {\n    id\n    name\n  }\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    value\n    typeId: custom_checkbox_type_id\n  }\n  assignments_aggregate {\n    aggregate {\n      count\n    }\n  }\n  actuals_aggregate {\n    aggregate {\n      count\n    }\n  }\n  links {\n    id\n    name\n    href\n    show_in_planner\n  }\n  ...PersonCustomEditor_person\n  ...ExtLinks_Person\n  ...PersonActionButtons_person\n  ...ConfirmContractForm_person\n}\n\nfragment ExtLinks_Person on people {\n  ext_person_links(where: {active: {_eq: true}}) {\n    person_id\n    ext_person_id\n    active\n    external_id: ext_person_id\n    external: ext_person {\n      id\n      __typename\n      first_name\n      last_name\n      email\n      remote_id\n      integration_id\n    }\n  }\n}\n\nfragment PersonActionButtons_person on people {\n  id\n  is_placeholder\n  email\n  first_name\n  last_name\n  active\n  archivable\n  assignments_aggregate {\n    aggregate {\n      count\n    }\n  }\n  actuals_aggregate {\n    aggregate {\n      count\n    }\n  }\n}\n\nfragment PersonCustomEditor_person on people {\n  id\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    value\n    typeId: custom_checkbox_type_id\n  }\n}\n\nfragment PersonSidePanelContract_person on people {\n  id\n  contracts {\n    id\n    cost: cost_private\n    employment_type\n    job_title\n    minutes_per_day\n    rostered_days\n    start_date: start_date_runn\n    end_date: end_date_runn\n    role {\n      name\n      default_hour_cost: default_hour_cost_private\n    }\n  }\n}\n\nfragment PersonSidePanelDetails_person on people {\n  id\n  first_name\n  last_name\n  email\n  tags\n  references\n  holidays_group {\n    id\n    name\n  }\n  custom_text_values {\n    value\n    typeId: custom_text_type_id\n  }\n  custom_select_values {\n    optionId: custom_select_option_id\n    typeId: custom_select_type_id\n  }\n  custom_checkbox_values {\n    typeId: custom_checkbox_type_id\n    value\n  }\n  custom_date_values {\n    value\n    typeId: custom_date_type_id\n  }\n  team {\n    id\n    name\n  }\n  competencies {\n    id\n    level\n    skill {\n      id\n      name\n    }\n  }\n  links {\n    id\n    href\n    name\n    show_in_planner\n  }\n}\n\nfragment PersonSidePanelNotes_person on people {\n  id\n  email\n  is_placeholder\n  people_notes {\n    id\n    note\n    created_at\n    updated_at\n    creator_email\n    created_by\n    user_id\n    user_account {\n      id\n      user {\n        id\n        first_name\n        last_name\n        email\n      }\n    }\n  }\n}\n\nfragment PersonSidePanel_person on people {\n  id\n  first_name\n  last_name\n  email\n  image_key\n  team {\n    id\n    name\n  }\n  contracts {\n    id\n    start_date: start_date_runn\n    end_date: end_date_runn\n    role {\n      id\n      name\n    }\n    job_title\n  }\n  people_notes_aggregate {\n    aggregate {\n      count\n    }\n  }\n  ...PersonSidePanelDetails_person\n  ...PersonCustomEditor_person\n  ...PersonActionButtons_person\n  ...EditPersonForm_person\n  ...PersonSidePanelContract_person\n  ...PersonSidePanelNotes_person\n}\n"
  }
};
})();

(node as any).hash = "fc0c8123bf729877b0a60a3ae053a928";

export default node;
